import { useMutation } from '@tanstack/react-query';
import { API } from 'api';
import { DOMAINS, IMPORTANCE, SECTIONS } from '@repo/monitoring';

import { apiBasePath, apiName } from 'assets/constants';

const requestAccountDeletion = async () => {
  const response = await API.post(
    apiName,
    `${apiBasePath}/mainaccounts/deletion-request`,
    {},
    true,
    undefined,
    {
      tags: {
        section: SECTIONS.ACCOUNT,
        domain: DOMAINS.ACCOUNT,
        importance: IMPORTANCE.HIGH,
      },
      context: {},
    },
  );
  return response?.result;
};

const useRequestAccountDeletion = () =>
  useMutation({ mutationFn: requestAccountDeletion });

export default useRequestAccountDeletion;
